import { render, staticRenderFns } from "./CheckoutDeliveryMethods.vue?vue&type=template&id=29f4cd56&scoped=true&"
import script from "./CheckoutDeliveryMethods.vue?vue&type=script&lang=js&"
export * from "./CheckoutDeliveryMethods.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutDeliveryMethods.vue?vue&type=style&index=0&id=29f4cd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f4cd56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
